'use client';
import { useLocalStorage } from '@/hooks/useLocalStorage.hook';
import { WEBFLOW_PATH } from '../event-layer';
import Button from '../../button';
import styles from './RDD-2025.module.css';
import { EventPath } from '@lib/flags';

type RDD2025Props = {
  eventPath: EventPath | null;
  onClose: () => void;
};

export const RDD2025 = ({ eventPath, onClose }: RDD2025Props) => {
  const { setStorage } = useLocalStorage();

  return (
    <div className={styles.buttonWrapper}>
      <div className="flex w-[356px] gap-[16px]">
        <Button
          variant="secondary"
          size="large"
          className="flex-1"
          onClick={() => {
            onClose();
          }}
        >
          Go to Home
        </Button>
        <Button
          variant="secondary"
          size="large"
          className="flex-1 bg-[rgba(246,247,254,0.29)] text-white"
          onClick={() => {
            onClose();
            window.open(`${WEBFLOW_PATH}/${eventPath?.detailPath}`, '_blank');
          }}
        >
          Learn More
        </Button>
      </div>
      <div>
        <span
          className="cursor-pointer text-sm text-3b-text-secondary underline"
          onClick={() => {
            onClose();
            setStorage(eventPath?.mainPath ?? '', 'true');
          }}
        >
          Do not show again
        </span>
      </div>
    </div>
  );
};
